
<template>
    <b-overlay :show="showOverlay" rounded="sm">
        <b-form ref="form" v-on:submit.prevent="createAccount">
            <div v-if="regStep==1">
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="country" class="reg-label">{{$t('regForm.country')}}</label>
                        <select id="country" class="custom-select w-100" required v-model="form.country" style="height: 47px; padding: 5px;">
                            <option style="color: red;" value=""></option>
                            <option style="color: red;" v-for="country in countries" :value="country.code">{{ country.name }}</option>
                        </select>
                    </b-col>
                </b-form-row>
                <!-- begining of the company information -->
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="bin" class="reg-label">{{$t('regForm.orgBin')}}</label>
                        <input type="text"  id="bin" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.orgBin">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="orgName" class="reg-label">{{$t('regForm.orgName')}}</label>
                        <input type="text"  id="orgName" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.orgName">
                    </b-col>
                </b-form-row>
                <b-form-row  class="mt-3">
                    <h4 class="reg-step-title text-center w-100">Прикрепить документы</h4>
                    <div class="reg-step-desc text-center w-100">Пожалуйста, приложите документы компании.  (.jpg, .jpeg, .png, .gif, .pdf)</div>
                    <b-form-file
                        accept=".jpg, .jpeg, .png, .gif"
                        class="my-2"
                        v-model="form.orgDoc"
                        :state="Boolean(form.orgDoc)"
                        placeholder="Прикрепление документа.."
                        drop-placeholder=""
                    ></b-form-file>
                </b-form-row>
                <!-- end of the company information -->


                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="fio" class="reg-label">{{$t('regForm.fio')}}</label>
                        <input type="text"  id="fio" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.displayName">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="iin" class="reg-label">{{$t('regForm.iin')}}</label>
                        <input type="text"  id="iin" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.iin">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="email" class="reg-label">{{$t('regForm.email')}}</label>
                        <input type="email"  id="email" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.email">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="phoneNumber" class="reg-label">{{$t('regForm.phoneNumber')}}</label>
                        <input type="text"  id="phoneNumber" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.phoneNumber">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="password" class="reg-label">{{$t('regForm.password')}}</label>
                        <input type="password"  id="password" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.password">
                    </b-col>
                </b-form-row>
                <b-form-row class="mt-3">
                    <b-col sm="auto" lg="12">
                        <label for="passwordre" class="reg-label">{{$t('regForm.passwordre')}}</label>
                        <input type="password"  id="passwordre" 
                            class="reg-input w-100 p-2" 
                            required
                            v-model="form.passwordre">
                    </b-col>
                </b-form-row>
            </div>
            <div v-if="regStep==2">
                <b-form-row  class="mt-3">
                    <h4 class="reg-step-title text-center w-100">Прикрепить документы</h4>
                    <div class="reg-step-desc text-center w-100">Для подтверждения вашей личности мы сопоставим ваше селфи с предоставленной вами фотографией в документе.  (.jpg, .jpeg, .png, .gif)</div>
                    <b-form-file
                        accept=".jpg, .jpeg, .png, .gif"
                        class="my-2"
                        v-model="form.userDoc"
                        :state="Boolean(form.userDoc)"
                        placeholder="Прикрепление документа.."
                        drop-placeholder=""
                    ></b-form-file>
                </b-form-row>
            </div>
            <b-form-row v-if="regStep==3">
                <h4 class="reg-step-title text-center mt-3 w-100 mb-4">Сделайте селфи</h4>
                <div class="reg-step-desc text-center">Для подтверждения вашей личности мы сопоставим ваше селфи с предоставленной вами фотографией в документе.</div>
                <div>
                    <div class="ins-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#00C076"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.4477 7 11 7.44772 11 8C11 8.55229 11.4477 9 12 9C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7ZM12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12C13 11.4477 12.5523 11 12 11Z" fill="#00C076"/>
                        </svg>
                        <span class="float-right ins-item-text  d-inline-block" style="width: 88%;">ППодготовьте действительный документ.</span>
                    </div>
                    <div class="ins-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#00C076"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.4477 7 11 7.44772 11 8C11 8.55229 11.4477 9 12 9C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7ZM12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12C13 11.4477 12.5523 11 12 11Z" fill="#00C076"/>
                        </svg>
                        <span class="float-right ins-item-text d-inline-block" style="width: 88%;">Проверьте, открыта ли камера вашего устройства и работает ли она</span>
                    </div>
                    <div class="ins-item w-100 d-block mt-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="float:left;">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#00C076"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.4477 7 11 7.44772 11 8C11 8.55229 11.4477 9 12 9C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7ZM12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12C13 11.4477 12.5523 11 12 11Z" fill="#00C076"/>
                        </svg>
                        <span class="float-right ins-item-text  d-inline-block" style="width: 88%;">ПБудьте готовы сделать селфи и фотографии вашего документа.</span>
                    </div>
                    
                </div>
                <div class="web-camera-container mt-3">
                    <div class="camera-button">
                        <button type="button" class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
                            <span v-if="!isCameraOpen">открыть камеру</span>
                            <span v-else>закрыть камеру</span>
                        </button>
                    </div>
                    
                    <div v-show="isCameraOpen && isLoading" class="camera-loading">
                        <ul class="loader-circle">
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                    <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                        <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                        <video v-show="!isPhotoTaken" ref="camera" :width="350" :height="350" autoplay></video>
                        <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="350" :height="350"></canvas>
                    </div>
                    
                    <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                        <button type="button" class="button" @click="takePhoto">
                            <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
                        </button>
                    </div>
                    
                    <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                        <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                            выбрать
                        </a>
                    </div>
                </div>
            </b-form-row>
            <b-form-row v-if="regStep==3" class="mt-3">
                <b-col lg="12" class="d-flex justify-content-center">
                    <div ref="turnstile"></div>
                </b-col>
            </b-form-row>
            <b-form-row class="mt-3">
                <b-col sm="auto" lg="12">
                    <button @click="regNext()" type="button" class="submit-btn w-100 py-2">
                        <span class="submit-btn-text">{{$t('regForm.createAccount')}}</span>
                    </button>
                    <div @click="regBack()" v-if="regStep>1" class="mt-2 back-btn-container w-100 text-center py-2">
                        <span class="back-btn-text">Назад</span>
                    </div>
                </b-col>
            </b-form-row>
        </b-form>
    </b-overlay>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeaderOpen} from "@/config/config";
    import vue from 'vue';
    export default {
        name: 'OrgReg',
        data(){
            return{
                regStep:1,
                form:{
                    orgName:"",
                    orgBin:"",
                    orgDoc:null,
                    country:"",
                    displayName:"",
                    iin:"",
                    email:"",
                    password:"",
                    passwordre:"",
                    userDoc:null,
                    takenPhoto:"",
                    isOrg:1
                },
                showOverlay: false,
                turnstileToken: '',
                turnstileWidgetId: null,
                countries:
                [ 
                    {name: 'Afghanistan', code: 'AF'}, 
                    {name: 'Åland Islands', code: 'AX'}, 
                    {name: 'Albania', code: 'AL'}, 
                    {name: 'Algeria', code: 'DZ'}, 
                    {name: 'American Samoa', code: 'AS'}, 
                    {name: 'AndorrA', code: 'AD'}, 
                    {name: 'Angola', code: 'AO'}, 
                    {name: 'Anguilla', code: 'AI'}, 
                    {name: 'Antarctica', code: 'AQ'}, 
                    {name: 'Antigua and Barbuda', code: 'AG'}, 
                    {name: 'Argentina', code: 'AR'}, 
                    {name: 'Armenia', code: 'AM'}, 
                    {name: 'Aruba', code: 'AW'}, 
                    {name: 'Australia', code: 'AU'}, 
                    {name: 'Austria', code: 'AT'}, 
                    {name: 'Azerbaijan', code: 'AZ'}, 
                    {name: 'Bahamas', code: 'BS'}, 
                    {name: 'Bahrain', code: 'BH'}, 
                    {name: 'Bangladesh', code: 'BD'}, 
                    {name: 'Barbados', code: 'BB'}, 
                    {name: 'Belarus', code: 'BY'}, 
                    {name: 'Belgium', code: 'BE'}, 
                    {name: 'Belize', code: 'BZ'}, 
                    {name: 'Benin', code: 'BJ'}, 
                    {name: 'Bermuda', code: 'BM'}, 
                    {name: 'Bhutan', code: 'BT'}, 
                    {name: 'Bolivia', code: 'BO'}, 
                    {name: 'Bosnia and Herzegovina', code: 'BA'}, 
                    {name: 'Botswana', code: 'BW'}, 
                    {name: 'Bouvet Island', code: 'BV'}, 
                    {name: 'Brazil', code: 'BR'}, 
                    {name: 'British Indian Ocean Territory', code: 'IO'}, 
                    {name: 'Brunei Darussalam', code: 'BN'}, 
                    {name: 'Bulgaria', code: 'BG'}, 
                    {name: 'Burkina Faso', code: 'BF'}, 
                    {name: 'Burundi', code: 'BI'}, 
                    {name: 'Cambodia', code: 'KH'}, 
                    {name: 'Cameroon', code: 'CM'}, 
                    {name: 'Canada', code: 'CA'}, 
                    {name: 'Cape Verde', code: 'CV'}, 
                    {name: 'Cayman Islands', code: 'KY'}, 
                    {name: 'Central African Republic', code: 'CF'}, 
                    {name: 'Chad', code: 'TD'}, 
                    {name: 'Chile', code: 'CL'}, 
                    {name: 'China', code: 'CN'}, 
                    {name: 'Christmas Island', code: 'CX'}, 
                    {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
                    {name: 'Colombia', code: 'CO'}, 
                    {name: 'Comoros', code: 'KM'}, 
                    {name: 'Congo', code: 'CG'}, 
                    {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
                    {name: 'Cook Islands', code: 'CK'}, 
                    {name: 'Costa Rica', code: 'CR'}, 
                    {name: 'Cote D\'Ivoire', code: 'CI'}, 
                    {name: 'Croatia', code: 'HR'}, 
                    {name: 'Cuba', code: 'CU'}, 
                    {name: 'Cyprus', code: 'CY'}, 
                    {name: 'Czech Republic', code: 'CZ'}, 
                    {name: 'Denmark', code: 'DK'}, 
                    {name: 'Djibouti', code: 'DJ'}, 
                    {name: 'Dominica', code: 'DM'}, 
                    {name: 'Dominican Republic', code: 'DO'}, 
                    {name: 'Ecuador', code: 'EC'}, 
                    {name: 'Egypt', code: 'EG'}, 
                    {name: 'El Salvador', code: 'SV'}, 
                    {name: 'Equatorial Guinea', code: 'GQ'}, 
                    {name: 'Eritrea', code: 'ER'}, 
                    {name: 'Estonia', code: 'EE'}, 
                    {name: 'Ethiopia', code: 'ET'}, 
                    {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
                    {name: 'Faroe Islands', code: 'FO'}, 
                    {name: 'Fiji', code: 'FJ'}, 
                    {name: 'Finland', code: 'FI'}, 
                    {name: 'France', code: 'FR'}, 
                    {name: 'French Guiana', code: 'GF'}, 
                    {name: 'French Polynesia', code: 'PF'}, 
                    {name: 'French Southern Territories', code: 'TF'}, 
                    {name: 'Gabon', code: 'GA'}, 
                    {name: 'Gambia', code: 'GM'}, 
                    {name: 'Georgia', code: 'GE'}, 
                    {name: 'Germany', code: 'DE'}, 
                    {name: 'Ghana', code: 'GH'}, 
                    {name: 'Gibraltar', code: 'GI'}, 
                    {name: 'Greece', code: 'GR'}, 
                    {name: 'Greenland', code: 'GL'}, 
                    {name: 'Grenada', code: 'GD'}, 
                    {name: 'Guadeloupe', code: 'GP'}, 
                    {name: 'Guam', code: 'GU'}, 
                    {name: 'Guatemala', code: 'GT'}, 
                    {name: 'Guernsey', code: 'GG'}, 
                    {name: 'Guinea', code: 'GN'}, 
                    {name: 'Guinea-Bissau', code: 'GW'}, 
                    {name: 'Guyana', code: 'GY'}, 
                    {name: 'Haiti', code: 'HT'}, 
                    {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
                    {name: 'Holy See (Vatican City State)', code: 'VA'}, 
                    {name: 'Honduras', code: 'HN'}, 
                    {name: 'Hong Kong', code: 'HK'}, 
                    {name: 'Hungary', code: 'HU'}, 
                    {name: 'Iceland', code: 'IS'}, 
                    {name: 'India', code: 'IN'}, 
                    {name: 'Indonesia', code: 'ID'}, 
                    {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
                    {name: 'Iraq', code: 'IQ'}, 
                    {name: 'Ireland', code: 'IE'}, 
                    {name: 'Isle of Man', code: 'IM'}, 
                    {name: 'Israel', code: 'IL'}, 
                    {name: 'Italy', code: 'IT'}, 
                    {name: 'Jamaica', code: 'JM'}, 
                    {name: 'Japan', code: 'JP'}, 
                    {name: 'Jersey', code: 'JE'}, 
                    {name: 'Jordan', code: 'JO'}, 
                    {name: 'Kazakhstan', code: 'KZ'}, 
                    {name: 'Kenya', code: 'KE'}, 
                    {name: 'Kiribati', code: 'KI'}, 
                    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
                    {name: 'Korea, Republic of', code: 'KR'}, 
                    {name: 'Kuwait', code: 'KW'}, 
                    {name: 'Kyrgyzstan', code: 'KG'}, 
                    {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
                    {name: 'Latvia', code: 'LV'}, 
                    {name: 'Lebanon', code: 'LB'}, 
                    {name: 'Lesotho', code: 'LS'}, 
                    {name: 'Liberia', code: 'LR'}, 
                    {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
                    {name: 'Liechtenstein', code: 'LI'}, 
                    {name: 'Lithuania', code: 'LT'}, 
                    {name: 'Luxembourg', code: 'LU'}, 
                    {name: 'Macao', code: 'MO'}, 
                    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
                    {name: 'Madagascar', code: 'MG'}, 
                    {name: 'Malawi', code: 'MW'}, 
                    {name: 'Malaysia', code: 'MY'}, 
                    {name: 'Maldives', code: 'MV'}, 
                    {name: 'Mali', code: 'ML'}, 
                    {name: 'Malta', code: 'MT'}, 
                    {name: 'Marshall Islands', code: 'MH'}, 
                    {name: 'Martinique', code: 'MQ'}, 
                    {name: 'Mauritania', code: 'MR'}, 
                    {name: 'Mauritius', code: 'MU'}, 
                    {name: 'Mayotte', code: 'YT'}, 
                    {name: 'Mexico', code: 'MX'}, 
                    {name: 'Micronesia, Federated States of', code: 'FM'}, 
                    {name: 'Moldova, Republic of', code: 'MD'}, 
                    {name: 'Monaco', code: 'MC'}, 
                    {name: 'Mongolia', code: 'MN'}, 
                    {name: 'Montserrat', code: 'MS'}, 
                    {name: 'Morocco', code: 'MA'}, 
                    {name: 'Mozambique', code: 'MZ'}, 
                    {name: 'Myanmar', code: 'MM'}, 
                    {name: 'Namibia', code: 'NA'}, 
                    {name: 'Nauru', code: 'NR'}, 
                    {name: 'Nepal', code: 'NP'}, 
                    {name: 'Netherlands', code: 'NL'}, 
                    {name: 'Netherlands Antilles', code: 'AN'}, 
                    {name: 'New Caledonia', code: 'NC'}, 
                    {name: 'New Zealand', code: 'NZ'}, 
                    {name: 'Nicaragua', code: 'NI'}, 
                    {name: 'Niger', code: 'NE'}, 
                    {name: 'Nigeria', code: 'NG'}, 
                    {name: 'Niue', code: 'NU'}, 
                    {name: 'Norfolk Island', code: 'NF'}, 
                    {name: 'Northern Mariana Islands', code: 'MP'}, 
                    {name: 'Norway', code: 'NO'}, 
                    {name: 'Oman', code: 'OM'}, 
                    {name: 'Pakistan', code: 'PK'}, 
                    {name: 'Palau', code: 'PW'}, 
                    {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
                    {name: 'Panama', code: 'PA'}, 
                    {name: 'Papua New Guinea', code: 'PG'}, 
                    {name: 'Paraguay', code: 'PY'}, 
                    {name: 'Peru', code: 'PE'}, 
                    {name: 'Philippines', code: 'PH'}, 
                    {name: 'Pitcairn', code: 'PN'}, 
                    {name: 'Poland', code: 'PL'}, 
                    {name: 'Portugal', code: 'PT'}, 
                    {name: 'Puerto Rico', code: 'PR'}, 
                    {name: 'Qatar', code: 'QA'}, 
                    {name: 'Reunion', code: 'RE'}, 
                    {name: 'Romania', code: 'RO'}, 
                    {name: 'Russian Federation', code: 'RU'}, 
                    {name: 'RWANDA', code: 'RW'}, 
                    {name: 'Saint Helena', code: 'SH'}, 
                    {name: 'Saint Kitts and Nevis', code: 'KN'}, 
                    {name: 'Saint Lucia', code: 'LC'}, 
                    {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
                    {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
                    {name: 'Samoa', code: 'WS'}, 
                    {name: 'San Marino', code: 'SM'}, 
                    {name: 'Sao Tome and Principe', code: 'ST'}, 
                    {name: 'Saudi Arabia', code: 'SA'}, 
                    {name: 'Senegal', code: 'SN'}, 
                    {name: 'Serbia and Montenegro', code: 'CS'}, 
                    {name: 'Seychelles', code: 'SC'}, 
                    {name: 'Sierra Leone', code: 'SL'}, 
                    {name: 'Singapore', code: 'SG'}, 
                    {name: 'Slovakia', code: 'SK'}, 
                    {name: 'Slovenia', code: 'SI'}, 
                    {name: 'Solomon Islands', code: 'SB'}, 
                    {name: 'Somalia', code: 'SO'}, 
                    {name: 'South Africa', code: 'ZA'}, 
                    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
                    {name: 'Spain', code: 'ES'}, 
                    {name: 'Sri Lanka', code: 'LK'}, 
                    {name: 'Sudan', code: 'SD'}, 
                    {name: 'Suriname', code: 'SR'}, 
                    {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
                    {name: 'Swaziland', code: 'SZ'}, 
                    {name: 'Sweden', code: 'SE'}, 
                    {name: 'Switzerland', code: 'CH'}, 
                    {name: 'Syrian Arab Republic', code: 'SY'}, 
                    {name: 'Taiwan, Province of China', code: 'TW'}, 
                    {name: 'Tajikistan', code: 'TJ'}, 
                    {name: 'Tanzania, United Republic of', code: 'TZ'}, 
                    {name: 'Thailand', code: 'TH'}, 
                    {name: 'Timor-Leste', code: 'TL'}, 
                    {name: 'Togo', code: 'TG'}, 
                    {name: 'Tokelau', code: 'TK'}, 
                    {name: 'Tonga', code: 'TO'}, 
                    {name: 'Trinidad and Tobago', code: 'TT'}, 
                    {name: 'Tunisia', code: 'TN'}, 
                    {name: 'Turkey', code: 'TR'}, 
                    {name: 'Turkmenistan', code: 'TM'}, 
                    {name: 'Turks and Caicos Islands', code: 'TC'}, 
                    {name: 'Tuvalu', code: 'TV'}, 
                    {name: 'Uganda', code: 'UG'}, 
                    {name: 'Ukraine', code: 'UA'}, 
                    {name: 'United Arab Emirates', code: 'AE'}, 
                    {name: 'United Kingdom', code: 'GB'}, 
                    {name: 'United States', code: 'US'}, 
                    {name: 'United States Minor Outlying Islands', code: 'UM'}, 
                    {name: 'Uruguay', code: 'UY'}, 
                    {name: 'Uzbekistan', code: 'UZ'}, 
                    {name: 'Vanuatu', code: 'VU'}, 
                    {name: 'Venezuela', code: 'VE'}, 
                    {name: 'Viet Nam', code: 'VN'}, 
                    {name: 'Virgin Islands, British', code: 'VG'}, 
                    {name: 'Virgin Islands, U.S.', code: 'VI'}, 
                    {name: 'Wallis and Futuna', code: 'WF'}, 
                    {name: 'Western Sahara', code: 'EH'}, 
                    {name: 'Yemen', code: 'YE'}, 
                    {name: 'Zambia', code: 'ZM'}, 
                    {name: 'Zimbabwe', code: 'ZW'} 
                ],
                isCameraOpen: false,
                isPhotoTaken: false,
                isShotPhoto: false,
                isLoading: false,
                link: '#'
            }
        },
        computed:{
            turnstileSiteKey(){
                // Публичный Site Key Cloudflare Turnstile; переопределяется через env.
                return process.env.VUE_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAFe9KnHziunj8ygU'
            },
        },
        watch:{
            regStep(val){
                if(val===3) this.$nextTick(()=>this.renderTurnstile())
            },
        },
        methods:{
            loadTurnstileScript(){
                return new Promise((resolve)=>{
                    if(window.turnstile){ resolve(); return }
                    const existing = document.getElementById('cf-turnstile-script')
                    if(existing){ existing.addEventListener('load', ()=>resolve()); return }
                    const s = document.createElement('script')
                    s.id = 'cf-turnstile-script'
                    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
                    s.async = true; s.defer = true
                    s.onload = ()=>resolve()
                    document.head.appendChild(s)
                })
            },
            renderTurnstile(){
                this.loadTurnstileScript().then(()=>{
                    const el = this.$refs.turnstile
                    if(!el || !window.turnstile) return
                    if(this.turnstileWidgetId!==null) return
                    this.turnstileWidgetId = window.turnstile.render(el, {
                        sitekey: this.turnstileSiteKey,
                        callback: (token)=>{ this.turnstileToken = token },
                        'error-callback': ()=>{ this.turnstileToken = '' },
                        'expired-callback': ()=>{ this.turnstileToken = '' },
                    })
                })
            },
            resetTurnstile(){
                this.turnstileToken = ''
                if(window.turnstile && this.turnstileWidgetId!==null){
                    try { window.turnstile.reset(this.turnstileWidgetId) } catch(e){ /* noop */ }
                }
            },
            validateForm() {
                const isValid = this.$refs.form.reportValidity();
                return isValid
            },
            regNext(){
                if(this.regStep<3){
                    if(this.form.orgDoc==null){
                        this.$bvToast.toast(vue.i18n.translate("ex.chooseOrgFile"), {
                            toaster:'b-toaster-top-center',
                            variant: "danger",
                            autoHideDelay: 3000
                        });
                        return 
                    }
                    if(this.validateForm()){
                        this.regStep++;
                    }
                }
                if(this.regStep==3){
                    if(this.validateForm()){
                        this.createAccount();
                    }
                }
            },
            regBack(){
                if(this.regStep>1){
                    this.regStep--;
                }
            },  
            toggleCamera() {
                if(this.isCameraOpen) {
                    this.isCameraOpen = false;
                    this.isPhotoTaken = false;
                    this.isShotPhoto = false;
                    this.stopCameraStream();
                } else {
                    this.isCameraOpen = true;
                    this.createCameraElement();
                }
            },
                
            createCameraElement() {
                this.isLoading = true;
                const constraints = (window.constraints = {
                    audio: false,
                    video: true
                });


                navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                    this.isLoading = false;
                    this.$refs.camera.srcObject = stream;
                })
                .catch(error => {
                    this.isLoading = false;
                    alert("May the browser didn't support or there is some errors.");
                });
            },
                
            stopCameraStream() {
                let tracks = this.$refs.camera.srcObject.getTracks();

                        tracks.forEach(track => {
                            track.stop();
                        });
                },
                
                takePhoto() {
                    if(!this.isPhotoTaken) {
                        this.isShotPhoto = true;

                        const FLASH_TIMEOUT = 50;

                        setTimeout(() => {
                        this.isShotPhoto = false;
                        }, FLASH_TIMEOUT);
                    }
                    
                    this.isPhotoTaken = !this.isPhotoTaken;
                    
                    const context = this.$refs.canvas.getContext('2d');
                    context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
                },
                
                downloadImage() {
                    const download = document.getElementById("downloadPhoto");
                    // const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                    // .replace("image/jpeg", "image/octet-stream");
                    const base64ImageData = document.getElementById("photoTaken").toDataURL("image/jpeg");
                    //console.log("base64ImageData > ",base64ImageData);
                    this.form.takenPhoto = base64ImageData;
                    //download.setAttribute("href", canvas);
                },
            clearForm(){
                this.regStep=1;
                this.stopCameraStream();
                this.form = {
                    country:"",
                    displayName:"",
                    iin:"",
                    email:"",
                    password:"",
                    passwordre:"",
                    userDoc:null,
                    takenPhoto:"",
                    orgName:"",
                    orgBin:"",
                    orgDoc:null,
                    isOrg:1
                }
            },  
            createAccount(){
                console.log("createAccount");
                if(this.form.userDoc!=null && this.form.takenPhoto!="" && this.form.orgDoc!=null){                    
                    this.showOverlay=true;
                    let formData = new FormData();
                    formData.append("userDoc",this.form.userDoc);
                    formData.append("userJson",JSON.stringify(this.form));
                    formData.append("orgDoc",this.form.orgDoc);
                    formData.append("cf-turnstile-response", this.turnstileToken);

                    axios.post(apiDomain+'/user/open/create_account_with_doc',formData,{headers:getMultipartHeaderOpen()})
                    .then(()=>{
                        this.showOverlay=false;
                        this.$bvToast.toast(vue.i18n.translate("system.successMsg"), {
                            toaster:'b-toaster-top-center',
                            variant: "success",
                            autoHideDelay: 3000
                        });
                        this.clearForm();
                    })
                    .catch(error => {
                        if (error.response && error.response.status===403) {
                            this.$bvToast.toast('Проверка «я не робот» не пройдена. Обновите страницу и попробуйте снова.', {
                                toaster:'b-toaster-top-center',
                                variant: "danger",
                                autoHideDelay: 6000
                            });
                        } else {
                            alert(error.message);
                        }
                        this.resetTurnstile();
                        this.showOverlay=false;
                        this.stopCameraStream();
                    })
                }else{
                    this.showOverlay=false
                    this.$bvToast.toast(vue.i18n.translate("system.noFile"), {
                        toaster:'b-toaster-top-center',
                        variant: "danger",
                        autoHideDelay: 3000
                    })
                    return 
                }
            }
        }
    }
</script>